import "../styles_css/Projects.css";
import rightarrow from "../images/rightarrow.png";
import shadow1 from "../images/shadow1.png";
import shadow2 from "../images/shadow2.png";
import shadow3 from "../images/shadow3.png";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../styles_css/Hero.css";
import HeroSection from "../components/HeroSection";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";


const Projects = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Get project data from translations
 const projects = [
    {
      id: 1,
      title: t("projects.project1.title"),
      subtitle: t("projects.project1.subtitle"),
      description: t("projects.project1.description", { returnObjects: true }),
      imageTop: require("../images/dcs.svg"),
      imageBottom: require("../images/Project1_img_bottom.png"),
    },
    {
      id: 2,
      title: t("projects.project2.title"),
      subtitle: t("projects.project2.subtitle"),
      description: t("projects.project2.description", { returnObjects: true }),
      imageTop: require("../images/Project2_img_bottom.png"),
      imageBottom: require("../images/Project2_img_bottom.png"),
    },
    {
      id: 3,
      title: t("projects.project3.title"),
      subtitle: t("projects.project3.subtitle"),
      description: t("projects.project3.description", { returnObjects: true }),
      imageTop: require("../images/dcs.svg"),
      imageBottom: require("../images/Project3_img_bottom.png"),
    },
    {
      id: 4,
      title: t("projects.project4.title"),
      subtitle: t("projects.project4.subtitle"),
      description: t("projects.project4.description", { returnObjects: true }),
      imageTop: require("../images/Project4_img_top.png"),
      imageBottom: require("../images/Project4_img_bottom.png"),
    },
  ];

    const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <div>
   
   {/*Hero Section*/}



   <HeroSection
  heading={t("projects.hero.heading")}
  mainHeading={t("projects.hero.mainHeading")}
  subHeading={t("projects.hero.subHeading")}
  ctaText={t("Get Started")}
  showShadows={true} // ose false nëse nuk duash shadows
/>


      {/* Projects Section */}

      <div className="projects-container">
        {projects.map((project) => (
          <div 
             id={`project-${project.id}`}
            className="project-card" 
            key={project.id}
            style={{
              '--bg-image': `url(${project.imageTop})`
            }}
          >
            <div className="project-header">
              <div className="project-title-box">
                <div className="project-arrow-icon">
                  <svg width="35" height="35" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <p>{project.title}</p>
                <p>{project.subtitle}</p>
              </div>
            </div>
            
            <div className="project-content">
              <div className="project-description">
                {Array.isArray(project.description)
                  ? project.description.map((para, i) => <p key={i}>{para}</p>)
                  : <p>{project.description}</p>}
              </div>
            </div>
            
            <div className="project-image">
              <img src={project.imageBottom} alt={`${project.title} - Detail`} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;
